const STORAGE_KEY = "nm_feedback_content";

const DEFAULT_DATA = {
  sectionTitle: "*Разработка* проекта по *вашему заказу*",
  sectionDescription:
    "Если у вас остались вопросы, получите бесплатную консультацию по телефону или напишите нам в Whatsapp",
  phone: "+7 (8412) 23 47 97",
  popupTitle: "*Оставьте заявку* на ваш проект",
  popupSubtitle:
    "Если у вас остались вопросы, получите бесплатную консультацию по телефону или напишите нам в Whatapp",
  nameLabel: "Имя",
  emailLabel: "Email",
  phoneLabel: "Телефон",
  buttonText: "Отправить",
  caption:
    "Нажимая на кнопку, я соглашаюсь на обработку персональных данных и с правилами пользования Платформой",
  successMessage: "Заявка отправлена. Мы свяжемся с вами.",
};

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function formatAccentTitle(title) {
  return escapeHtml(title).replace(/\*([^*]+)\*/g, "<span>$1</span>");
}

function toTelHref(phone) {
  const digits = String(phone || "").replace(/\D/g, "");
  if (!digits) return "#";
  if (digits.length === 11 && digits.startsWith("8")) {
    return `tel:+7${digits.slice(1)}`;
  }
  if (digits.length === 11 && digits.startsWith("7")) {
    return `tel:+${digits}`;
  }
  return `tel:+${digits}`;
}

function normalizeData(raw) {
  const fallback = { ...DEFAULT_DATA };
  if (!raw || typeof raw !== "object") return fallback;

  const next = {};
  Object.keys(fallback).forEach((key) => {
    const value = String(raw[key] ?? fallback[key]).trim();
    next[key] = value || fallback[key];
  });
  return next;
}

function getFeedbackData() {
  const cached = window.NMApi?.cache?.feedback;
  if (cached) return normalizeData(cached);
  return normalizeData(DEFAULT_DATA);
}

function saveFeedbackData(data) {
  const normalized = normalizeData(data);
  if (window.NMApi) {
    window.NMApi.cache.feedback = normalized;
    window.NMApi.save("feedback", normalized).catch((error) => {
      window.alert(error.message || "Не удалось сохранить форму обратной связи"); // eslint-disable-line no-alert
    });
  }
  return normalized;
}

function setLabelText(root, fieldName, labelText) {
  const field = root.querySelector(`[data-feedback-field="${fieldName}"]`);
  if (!field) return;
  const label = field.querySelector(".form__label");
  if (label) label.textContent = labelText;
}

function applyFormTexts(form, data) {
  if (!form) return;
  setLabelText(form, "name", data.nameLabel);
  setLabelText(form, "email", data.emailLabel);
  setLabelText(form, "phone", data.phoneLabel);

  const buttonLabel = form.querySelector(".feedback-section__form-btn span");
  if (buttonLabel) buttonLabel.textContent = data.buttonText;

  const caption = form.querySelector(".feedback-section__form-caption");
  if (caption) {
    const policyLink = caption.querySelector("[data-policy-link]");
    const policyHtml = policyLink
      ? policyLink.outerHTML
      : "<a data-policy-link>персональных данных</a>";
    caption.innerHTML = escapeHtml(data.caption).replace(
      /персональных данных/gi,
      ` ${policyHtml} `,
    );
  }

  const success = form.querySelector("[data-feedback-success]");
  if (success) success.textContent = data.successMessage;
}

function hydrateSection(data) {
  document.querySelectorAll("section.feedback-section").forEach((section) => {
    const title = section.querySelector(".feedback-section__title");
    if (title) title.innerHTML = formatAccentTitle(data.sectionTitle);

    const desc = section.querySelector(".feedback-section__desc");
    if (desc) desc.textContent = data.sectionDescription;

    const phone = section.querySelector(".feedback-section__tel");
    if (phone) {
      phone.textContent = data.phone;
      phone.setAttribute("href", toTelHref(data.phone));
    }

    applyFormTexts(section.querySelector("[data-feedback-form]"), data);
  });
}

function hydratePopup(data) {
  const popup = document.querySelector("#popup-feedback");
  if (!popup) return;

  const title = popup.querySelector(".popup__title");
  if (title) title.innerHTML = formatAccentTitle(data.popupTitle);

  const subtitle = popup.querySelector(".popup__subtitle");
  if (subtitle) subtitle.textContent = data.popupSubtitle;

  applyFormTexts(popup.querySelector("[data-feedback-form]"), data);
}

function hydrateFeedback() {
  const data = getFeedbackData();
  hydrateSection(data);
  hydratePopup(data);
}

window.NMFeedbackContent = {
  STORAGE_KEY,
  escapeHtml,
  formatAccentTitle,
  toTelHref,
  getFeedbackData,
  saveFeedbackData,
  getDefaultData: () => normalizeData(DEFAULT_DATA),
  normalizeData,
  hydrateFeedback,
};

window.NMApi?.ready?.then(hydrateFeedback);
